import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {TranslateContext} from "../../../context/TranslateContext";
import {RuoliContext} from "../../../context/RuoliContext";
import {downloadTemplateDataPoint, getListaKpiApi, getTipiKpiApi, rimuoviKpiApi} from "../services/KpiServices";
import {getFrequenzeApi} from "../../frequenze/services/FrequenzeServices";
import ConfKpiView from "./ConfKpiView";
import {getMacrocategorieApi} from "../../macrocategorie/services/MacrocategorieServices";
import {getClassiTipiImpExpDatiApi} from "../../tipi_imp_exp_dati/services/TipiImpExpDatiServices";
import {STANDARD_ESRS} from "../../../utility/common";
import {ParametersContext} from "../../../context/ParametersContext";

export default function ConfKpiController() {

    const [loadingData, setLoadingData] = useState(true);
    const [kpi, setKpi] = useState([]);
    const [kpiSel, setKpiSel] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [frequenze, setFrequenze] = useState([]);
    const [macrocategorie, setMacrocategorie] = useState([]);
    const [classiImpExp, setClassiImpExp] = useState([]);
    const [tipiKpi, setTipiKpi] = useState([]);
    const [showModalUploadKpi, setShowModalUploadKpi] = useState(false);
    const [showEsrs, setShowEsrs] = useState(false);

    const history = useHistory();

    const {translate, lingua, loadingNewLang} = useContext(TranslateContext);
    const {isRuoloSuperAdmin} = useContext(RuoliContext);
    const {getParameterValue} = useContext(ParametersContext);

    const token = localStorage.getItem('ns-access-token');

    async function getListaKpi() {
        const response = await getListaKpiApi();
        setKpi(response.data.data);
        setLoadingData(false);
    }

    async function getFrequenze() {
        const response = await getFrequenzeApi();
        setFrequenze(response.data.data);
    }

    async function getTipiKpi() {
        const response = await getTipiKpiApi();
        setTipiKpi(response.data.data);
    }

    async function getMacrocategorie() {
        const response = await getMacrocategorieApi();
        setMacrocategorie(response.data.data);
    }

    async function getClassiImportExportDati() {
        const response = await getClassiTipiImpExpDatiApi();
        setClassiImpExp(response.data.data);
    }

    async function getEsrs() {
        let standards = await getParameterValue('StandardGestiti');
        setShowEsrs(standards.includes(STANDARD_ESRS));
    }

    useEffect(() => {
        if (loadingNewLang === false) {
            if (loadingData === true) {
                getFrequenze();
                getTipiKpi();
                getMacrocategorie();
                getClassiImportExportDati();
            }

            getEsrs();
            getListaKpi();
        }
    }, [lingua, loadingNewLang]);

    const eliminaKpi = async () => {
        setShowConfirm(false);
        const response = await rimuoviKpiApi(kpiSel.id_kpi);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            setKpi(response.data.data);
        }
    }

    const downloadTemplate = async () => {
        const response = await downloadTemplateDataPoint();
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            var a = document.createElement("a");
            a.href = "data:application/vnd.ms-excel;base64," + response.data.data;
            a.download = 'template-import-kpi.xlsx';
            a.click(); //Downloaded file
        }
    }

    const bottoniDx = [
        {
            label: translate("Aggiungi"),
            icon: "fas fa-plus-circle",
            command: () => {
                history.push("/upd-kpi");
            }
        },
        showEsrs && {
            label: 'Download template',
            icon: 'fas fa-file-excel',
            command: downloadTemplate
        },
        showEsrs && {
            label: 'Upload oggetti',
            icon: 'fas fa-file-upload',
            command: () => {
                setShowModalUploadKpi(true)
            }
        }
    ];

    function onKpiDbClick(row) {
        history.push("/upd-kpi/" + row.id_kpi)
    }

    return (
        <ConfKpiView
            translate={translate}
            show={show}
            setShowConfirm={setShowConfirm}
            modalMsg={modalMsg}
            kpiSel={kpiSel}
            loadingData={loadingData}
            kpi={kpi}
            isRuoloSuperAdmin={isRuoloSuperAdmin}
            setShow={setShow}
            showConfirm={showConfirm}
            frequenze={frequenze}
            classiImpExp={classiImpExp}
            eliminaKpi={eliminaKpi}
            setKpiSel={setKpiSel}
            macrocategorie={macrocategorie}
            bottoniDx={bottoniDx}
            onKpiDbClick={onKpiDbClick}
            tipiKpi={tipiKpi}
            showModalUploadKpi={showModalUploadKpi}
            setShowModalUploadKpi={setShowModalUploadKpi}
            updateDati={getListaKpi}
            token={token}
        />
    );
}
